<template>
    <div class="slider-outline bg-blur">
        <h2 class="heading d-flex justify-content-between">
            <span>
                本棚
            </span>
        </h2>
        <div class="slider">
            <div v-for="a in authors" :key="a.uid" class="slider-item">
                <a :href="authorLink(a)" class="text-reset" :target="a.subdomain">
                    <img v-lazy="authorIcon(a)" class="mx-auto d-block cover" />
                    <div class="slider-text">
                        <div class="bookshelf-name f-red">{{authorBookshelf(a)}}</div>
                        <div>
                            {{a.profile}}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.slider-outline {
    max-width: 100%;
    margin-top: 2.5rem;
    background-color: white;
    border-radius: .7rem .7rem 0 0;
    overflow: hidden;
    .slider {
        display: flex;
        margin: 0 30px;
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
        .slider-item {
            .cover {
                object-fit: cover;
                height: 205px;
                width: 205px;
                border-radius: 50%;
            }
            height: 396px;
            width: 235px;
            padding: 15px 15px;
            .slider-text {
                height: 136px;
                overflow: hidden;
                font-size: .7rem;
                border-top: 1px dashed #aaa;
                margin: 1rem 0 0;
                padding: .4rem .8rem;
                .bookshelf-name {
                    font-size: .9rem;
                }
            }
            a {
                color: #222;
                &:hover {
                    text-decoration: none;
                }
            }
            &:hover {
                opacity: .8;
            }
        }
        .novel-title {
            font-size: 1.1rem;
            font-weight: bold;
        }
    }
    .heading {
        font-size: 1rem;
        font-weight: bold;
        margin: 0;
        padding: 1rem 1rem .5rem;
    }
    .link {
        color: #222;
        font-size: .8rem;
        font-weight: lighter;
    }
}
@media screen and (max-width: 575px) {
    .slider-outline {
        .slider {
            margin: 0 5px;
        }
    }
}
</style>

<script>
export default {
    props: {
        authors: {
            required: true,
            default: [],
        },
        childClass: {
            default: "",
        },
    },
    methods: {
        authorLink(a) {
            return `//${a.subdomain}${this.$store.state.base_domain}`;
        },
        authorIcon(a) {
            if (a.profile_url) {
                return a.profile_url + '?' + a.profile_hash;
            }
            return "/favicon.png";
        },
        authorBookshelf(a) {
            if (a.bookshelf_name) {
                return a.bookshelf_name;
            }
            return a.name + "の本棚";
        },
    },
}
</script>